import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import { red, blue, bombasGreen, black, grey40, grey80 } from 'Styles/colors';
import breakpoint from 'Styles/breakpoints';
import BaseButton from '../Button/Button';
import TextInputOriginal from '../TextInput/TextInput';
import { Error } from '../FormInput/FormInput.styled';
import Icon from '../Icons/Icon';
import OverlayModal from '../ContentSystem/components/OverlayModal/OverlayModal';
import { Container as ModalContainer } from '../ContentSystem/components/OverlayModal/OverlayModal.styled';

export const Modal = styled(OverlayModal)`
  ${ModalContainer} {
    background-color: ${grey40};
    min-height: 364px;
  }
`;

export const Container = styled.div`
  margin: 24px auto;
  max-width: 328px;

  ${breakpoint('medium')} {
    max-width: unset;
  }
`;

export const ContentContainer = styled.div`
  text-align: center;
`;

export const Heading = styled.h1`
  margin: 0;
  color: ${blue};
  ${fontTitle(40)};
`;

export const HeadingSmall = styled(Heading)`
  ${fontTitle(24)}
  color: ${({ $color }) => ($color === 'green' ? bombasGreen : black)};
  margin-bottom: 8px;
`;

export const HeadingSmaller = styled(Heading)`
  ${fontTitle(18)}
  color: ${black};
  ${({ $withBottomMargin }) => $withBottomMargin && 'margin-bottom: 16px;'}
  text-align: center;
`;

export const SubHeading = styled.p`
  color: ${black};
  margin: 8px 0 16px;
  ${fontBody(14)}
`;

export const BodyCopy = styled.p`
  color: ${black};
  margin: 0 0 8px;
  ${fontBody(14)}
`;

export const BodyCopySuccess = styled(BodyCopy)`
  color: ${black};
`;

export const Button = styled(BaseButton)`
  margin-top: 24px;
  width: 100%;
`;

export const ButtonTextWrap = styled.div`
  display: flex;
`;

export const ButtonLink = styled(BaseButton).attrs({
  variant: 'secondary',
  isGhost: true,
  size: 'regular'
})`
  margin-top: 4px;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  width: 248px;
  margin: 0 auto;
`;

export const TextInput = styled(TextInputOriginal)`
  ${Error} {
    text-align: start;
    color: ${red};
  }

  ${breakpoint('medium')} {
    margin: 0 auto;
    width: 272px;
  }
`;

export const Disclaimer = styled.p`
  ${fontBody(12)};
  color: ${grey80};
  margin-top: 16px;

  a {
    color: ${grey80};
  }

  ${breakpoint('medium')} {
    padding: 0 160px;
  }
`;

export const Logo = styled(Icon).attrs({ name: 'logo-type', size: 20 })`
  margin-bottom: 32px;
`;

export const OfferMessageContainer = styled.div`
  margin: auto;
  max-width: 496px;
  margin-bottom: 40px;
`;

export const SubHeadingEmailSuccess = styled.p`
  color: ${black};
  margin: 4px 0 16px;
  ${fontBody(14)}
`;
